import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Time } from 'omni-package-react-core';
import { P } from 'ia-react-core';
import MailContent from './MailContent';
import { Message } from '../../../../interfaces/Message';
import { StyledDivider, StyledDivBottom, StyledDiv } from './Details.styles';
import AnswerMail from './AnswerMail';
import { StyledBoldText } from '../../MessageDetailsPage.styles';

export interface DetailsProps {
  message: Message;
}
const Details: FC<DetailsProps> = ({ message }) => {
  const { t } = useTranslation('MessageDetailsPage');
  if (!message) return null;
  return (
    <StyledDivBottom>
      <StyledDiv>
        <P><StyledBoldText>{t('object')}</StyledBoldText> {message?.subjectGroupDescription}</P>
        <P><StyledBoldText>{t('lob')}</StyledBoldText> {message?.businessLineDescription}</P>
        {message?.contractDescription && <P><StyledBoldText>{t('contract')}</StyledBoldText> {message?.contractDescription}</P>}
        {message?.expirationDateUTC &&
          <P><StyledBoldText>{t('expirationDate')}</StyledBoldText> <Time time={new Date(message?.expirationDateUTC)} isDateWithTime /></P>}
      </StyledDiv>
      <StyledDivider />
      <AnswerMail />
      <MailContent message={message} />
      <div id="mailHistorical">
        {message?.previousMessages ? message?.previousMessages?.map((mailMessage) => (
          <MailContent key={mailMessage.id} message={mailMessage} />
        )) : null}
      </div>
    </StyledDivBottom>
  );
};

export default Details;
